/**
 * LOCAL-ONLY (untracked) — the subset of `qa3b`'s report-constants that the
 * /dev/broadcast-sendto prototype imports. Everything here is copied verbatim from
 * `qa3b:apps/web/src/features/screen-reports/utils/report-constants.ts`; the entries
 * that depend on Screen Reports GraphQL documents (not on this branch) are omitted.
 * Delete this file once screen-reports lands on develop-us.
 */
import type { ReportFrequency } from './report-types';

/** Frequency options for the schedule RadioGroup. */
export const FREQUENCIES: ReadonlyArray<{ label: string; value: ReportFrequency }> = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekdays', value: 'weekdays' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Monthly', value: 'monthly' },
  { label: 'Custom (cron)', value: 'custom' },
] as const;

/** Hour run-window options (delivery happens in the chosen hour, tenant timezone). */
export const RUN_WINDOWS = Array.from({ length: 24 }, (_, hour) => {
  const label = `${String(hour).padStart(2, '0')}:00 - ${String((hour + 1) % 24).padStart(2, '0')}:00`;
  return { label, value: hour };
}) as ReadonlyArray<{ label: string; value: number }>;

/** Build timezone options from the Intl API (copied from pop-constants). */
export function getTimezoneOptions(): Array<{ label: string; value: string }> {
  try {
    const timezones = Intl.supportedValuesOf('timeZone');
    return timezones.map((tz) => {
      const offset = getTimezoneOffset(tz);
      return { label: `${tz} (GMT ${offset})`, value: tz };
    });
  } catch {
    // Fallback for older browsers
    return [
      {
        label: Intl.DateTimeFormat().resolvedOptions().timeZone,
        value: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    ];
  }
}

function getTimezoneOffset(tz: string): string {
  const now = new Date();
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    timeZoneName: 'shortOffset',
  });
  const parts = formatter.formatToParts(now);
  const offsetPart = parts.find((p) => p.type === 'timeZoneName');
  return offsetPart?.value?.replace('GMT', '') || '+0';
}
